import { render, staticRenderFns } from "./AffiliateIsMarked.vue?vue&type=template&id=0c9124d1&scoped=true&"
import script from "./AffiliateIsMarked.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateIsMarked.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateIsMarked.vue?vue&type=style&index=0&id=0c9124d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9124d1",
  null
  
)

export default component.exports